<template>
	<div v-show="show">
		<vx-card>
			<vs-row v-if="depotCreatePermission">
				<div class="vx-col w-full">
					<DepotForm :data="skillItem" :isEditActive="false" />
				</div>
			</vs-row>
			<not-permission v-else></not-permission>
		</vx-card>
	</div>
</template>
<script>
import DepotForm from "@/components/depot/DepotForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "Team",
	data() {
		return {
			skillItem: {},
			show: false,
		};
	},
	components: {
		DepotForm,
		NotPermission,
	},
	computed: {
		depotCreatePermission() {
			return this.$store.getters.checkPermission("DEPOSITS_C");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
